import { Prize, PrizeGroup, Range } from 'app/src/services/welfareportal/membership-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const rangeSchema: z.ZodType<Range> = z.object({
  from: z.number().min(0).max(999999.99),
  fromInclusive: z.boolean(),
  to: z.number().min(0).max(999999.99).optional(),
  toInclusive: z.boolean(),
})

export const prizeSchema: z.ZodType<Prize> = z.object({
  rangeType: z.enum(['amount', 'percentage']),
  range: rangeSchema,
  prizeType: z.enum(['amount', 'percentage']),
  prize: z.number().min(0).max(999999.99),
})

export const prizeGroupSchema: z.ZodType<PrizeGroup> = z.object({
  prizeGroupId: z.number(),
  name: z.string(),
  bonusAmountRange: rangeSchema,
  prizes: z.array(prizeSchema),
})
